export default __webpack_public_path__ + "static/media/04_B.2a0d0909.png";